export const INTEGRATIONS = [
  {
    id: 'ZAPIER',
    name: 'Zapier',
    logo: '/integrations/zapier-logo.svg',
    description: 'Integrate with Zapier to streamline workflows across hundreds of apps effortlessly.',
    documentationUrl: 'https://onvocado.com/support/integrating-onvocado-with-zapier/',
    requiresOAuth: false,
    component: 'Zapier',
  },
  {
    id: 'WEBHOOK',
    name: 'Webhook',
    logo: '/integrations/webhook.svg',
    description: 'Automate data exchange between platforms using Webhooks seamlessly.',
    documentationUrl: 'https://onvocado.com/support/setting-up-onvocado-webhooks/',
    requiresOAuth: false,
    component: 'Webhook',
  },
  {
    id: 'MAILCHIMP',
    name: 'Mailchimp',
    logo: '/integrations/mailchimp.svg',
    description: 'Easily sync your email lists and contacts with Mailchimp for targeted campaigns.',
    documentationUrl: 'https://onvocado.com/support/setting-up-mailchimp-integration/',
    requiresOAuth: true,
    component: 'Mailchimp',
  },
  {
    id: 'ACTIVECAMPAIGN',
    name: 'ActiveCampaign',
    logo: '/integrations/activecampaign.svg',
    description: 'Optimize your contact management with ActiveCampaign’s powerful tools.',
    documentationUrl: 'https://onvocado.com/support/setting-up-activecampaign-integration/',
    requiresOAuth: false,
    component: 'ActiveCampaign',
  },
  {
    id: 'AWEBER',
    name: 'AWeber',
    logo: '/integrations/aweber.svg',
    description: 'Effortlessly sync your contact lists with AWeber for effective communication.',
    documentationUrl: 'https://onvocado.com/support/setting-up-aweber-integration/',
    requiresOAuth: true,
    component: 'Aweber',
  },
  {
    id: 'BREVO',
    name: 'Brevo',
    logo: '/integrations/brevo.svg',
    description: 'Connect Brevo to easily synchronize and manage your contact data.',
    documentationUrl: 'https://onvocado.com/support/setting-up-brevo-integration/',
    requiresOAuth: true,
    component: 'Brevo',
  },
  {
    id: 'GETRESPONSE',
    name: 'GetResponse',
    logo: '/integrations/getresponse.svg',
    description: 'Leverage GetResponse for email marketing, automation, and content monetization.',
    documentationUrl: 'https://onvocado.com/support/setting-up-getresponse-integration/',
    requiresOAuth: false,
    component: 'GetResponse',
  },
  {
    id: 'SENDGRID',
    name: 'SendGrid',
    logo: '/integrations/twilio-sendgrid.svg',
    description: 'Ensure dependable email delivery with SendGrid’s trusted infrastructure.',
    documentationUrl: 'https://onvocado.com/support/setting-up-sendgrid-integration/',
    requiresOAuth: false,
    component: 'SendGrid',
  },
  {
    id: 'SENDFOX',
    name: 'SendFox',
    logo: '/integrations/sendfox.svg',
    description: 'Seamlessly integrate SendFox to keep your contact lists in sync.',
    documentationUrl: 'https://onvocado.com/support/setting-up-sendfox-integration/',
    requiresOAuth: false,
    component: 'SendFox',
  },
  {
    id: 'KLAVIYO',
    name: 'Klaviyo',
    logo: '/integrations/klaviyo.svg',
    description: 'Sync Klaviyo with ease to manage and grow your contact database.',
    documentationUrl: 'https://onvocado.com/support/setting-up-klaviyo-integration/',
    requiresOAuth: false,
    component: 'Klaviyo',
  },
  {
    id: 'OMNISEND',
    name: 'Omnisend',
    logo: '/integrations/omnisend.svg',
    description: 'Expand your reach with Omnisend’s advanced email marketing tools.',
    documentationUrl: 'https://onvocado.com/support/setting-up-omnisend-integration/',
    requiresOAuth: false,
    component: 'Omnisend',
  },
  {
    id: 'MAILJET',
    name: 'Mailjet',
    logo: '/integrations/mj_logo.svg',
    description: 'Effortlessly connect with Mailjet to keep your contact lists up-to-date.',
    documentationUrl: 'https://onvocado.com/support/setting-up-mailjet-integration/',
    requiresOAuth: false,
    component: 'Mailjet',
  },
  {
    id: 'MOOSEND',
    name: 'Moosend',
    logo: '/integrations/moosend.svg',
    description: 'Streamline your contact syncing process with Moosend integration.',
    documentationUrl: 'https://onvocado.com/support/setting-up-moosend-integration/',
    requiresOAuth: false,
    component: 'Moosend',
  },
  {
    id: 'MAILERLITE',
    name: 'MailerLite',
    logo: '/integrations/mailerlite.svg',
    description: 'Automatically sync and update your MailerLite subscribers in real-time for smoother, more targeted email campaigns.',
    documentationUrl: 'https://onvocado.com/support/setting-up-mailerlite-integration/',
    requiresOAuth: false,
    component: 'MailerLite',
  }
];
